/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Type_FractureInputs */

const en_us2_bodymap_type_fracture = /** @type {(inputs: Bodymap_Type_FractureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fracture`)
};

const pt_br2_bodymap_type_fracture = /** @type {(inputs: Bodymap_Type_FractureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fratura`)
};

const es_419_bodymap_type_fracture = /** @type {(inputs: Bodymap_Type_FractureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fractura`)
};

const pt_pt2_bodymap_type_fracture = /** @type {(inputs: Bodymap_Type_FractureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fratura`)
};

const fr_fr2_bodymap_type_fracture = /** @type {(inputs: Bodymap_Type_FractureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fracture`)
};

const de_de2_bodymap_type_fracture = /** @type {(inputs: Bodymap_Type_FractureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bruch`)
};

const it_it2_bodymap_type_fracture = /** @type {(inputs: Bodymap_Type_FractureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frattura`)
};

/**
* | output |
* | --- |
* | "Fracture" |
*
* @param {Bodymap_Type_FractureInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_type_fracture = /** @type {((inputs?: Bodymap_Type_FractureInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Type_FractureInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_type_fracture(inputs)
	if (locale === "es-419") return es_419_bodymap_type_fracture(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_type_fracture(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_type_fracture(inputs)
	if (locale === "de-DE") return de_de2_bodymap_type_fracture(inputs)
	if (locale === "it-IT") return it_it2_bodymap_type_fracture(inputs)
	return en_us2_bodymap_type_fracture(inputs)
});
export { bodymap_type_fracture as "bodymap.type.fracture" }